/**
 * Single entry point for all environment configuration.
 * Import from here — never read import.meta.env directly in individual files.
 *
 * All VITE_* values come from environment files or Cloudflare Pages settings.
 * No production values are hardcoded here — if a required variable is missing
 * the app throws at startup so the misconfiguration is caught immediately.
 */

function required(name) {
  const val = import.meta.env[name]
  if (!val) throw new Error(`${name} is required — set it in .env or Cloudflare Pages`)
  return val
}

export const API_BASE = required('VITE_API_BASE')
export const LOOM_URL = required('VITE_LOOM_URL')
export const ACCOUNT_URL = required('VITE_ACCOUNT_URL')

/**
 * Cookie domain for cross-subdomain auth cookie.
 * Local dev: set VITE_COOKIE_DOMAIN= (empty) → no domain restriction.
 * Production: set VITE_COOKIE_DOMAIN=.easeverse.ink
 * Uses ?? so empty string is honoured (not fallen back to default).
 */
export const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN ?? ''

/** Google OAuth client ID */
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

/**
 * Parsed extension ID list for auto-login bridge.
 * Required in production — without it, users coming from the Lens extension
 * can't hand off their session and get stuck on /auth.
 * Dev can leave it blank when not testing extension integration.
 */
const RAW_EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID || ''
if (import.meta.env.PROD && !RAW_EXTENSION_ID) {
  throw new Error(
    'VITE_EXTENSION_ID is required in production — set it in Cloudflare Pages environment variables'
  )
}
export const EXTENSION_IDS = RAW_EXTENSION_ID
  .split(',')
  .map(id => id.trim())
  .filter(Boolean)
